import { useMemo, useReducer, useState } from "react";
import { NakedTable, CustomModal, CustomTabs } from "components";
import { modalAction, modalReducer, modalInitialState } from "../reducers";
import {
  studentCoursePurchaseRecordsColumns,
  studentRecordColumns,
} from "../constants";
import { LessonDetail } from "./LessonDetail";
import { useQuery } from "react-query";
import apiService from "services/api";
import { StudentReport } from "./StudentReport";
import { InClassPhotos } from "./InClassPhotos";
import { Classwork } from "./Classwork";
import { AddPaymentModal } from "./AddPaymentModal";
import { permissionCheck, models, permission } from "utils/permissionCheck";
import EditHours from "./EditHours";

export const CourseDetail = ({
  coursePurchaseModalProps,
  coursePurchaseModalDispatch,
  showLessonDetailModal,
  lessonDetailModalProps,
  lessonDetailModalDispatch,
  refetch,
}) => {
  const { data: studentTraits } = useQuery(
    "studentTraits",
    () => apiService.student.traits.get(),
    {
      refetchOnWindowFocus: false,
    },
  );

  const { data: ledgerRecords } = useQuery(
    ["studentCourseLedgerData", coursePurchaseModalProps?.data?.id],
    () => {
      return apiService.student.getCourseLedgerRecords(
        coursePurchaseModalProps?.data?.id,
      );
    },
    {
      enabled: coursePurchaseModalProps.show,
    },
  );

  const [addPaymentModalProps, addPaymentModalDispatch] = useReducer(
    modalReducer,
    modalInitialState,
  );

  const lessonDetailTabs = useMemo(
    () => [
      {
        title: "Lesson Detail",
        component: () => (
          <LessonDetail
            studentRecord={
              lessonDetailModalProps?.data?.studentLessonRecord ||
              lessonDetailModalProps?.data
            }
          />
        ),
      },
      {
        title: "Student Performance",
        component: () => (
          <StudentReport
            studentReport={
              lessonDetailModalProps?.data?.studentLessonRecord?.studentReport
            }
          />
        ),
      },
      {
        title: "In Class Photos",
        component: () => (
          <InClassPhotos
            lessonFiles={lessonDetailModalProps?.data?.lessonFiles}
          />
        ),
      },
      {
        title: "Classwork",
        component: () => (
          <Classwork lessonFiles={lessonDetailModalProps?.data?.lessonFiles} />
        ),
      },
    ],
    [lessonDetailModalProps, studentTraits],
  );

  const courseDetailTabs = useMemo(
    () => [
      {
        title: "Lesson Records",
        component: () => (
          <NakedTable
            data={ledgerRecords ?? []}
            columns={studentRecordColumns({ showLessonDetailModal })}
          />
        ),
      },
      {
        title: "Purchase Records",
        component: () => (
          <NakedTable
            data={coursePurchaseModalProps?.data?.coursePurchaseRecords || []}
            columns={studentCoursePurchaseRecordsColumns({
              addPayment: (row) =>
                addPaymentModalDispatch({
                  type: modalAction.OPEN,
                  payload: row,
                }),
            })}
          />
        ),
      },
      ...(permissionCheck(
        apiService.auth.token.get(),
        models.STUDENT,
        permission.UPDATE,
      )
        ? [
            {
              title: "Manual Course Hours Edit",
              component: () => (
                <EditHours
                  studentCourseRecord={coursePurchaseModalProps?.data}
                  refetch={refetch}
                />
              ),
            },
          ]
        : []),
    ],
    [coursePurchaseModalProps, ledgerRecords],
  );

  return (
    <>
      <CustomModal
        compact={true}
        show={lessonDetailModalProps.show}
        hideModal={() => lessonDetailModalDispatch({ type: modalAction.CLOSE })}
        centered
        zIndex={1}
      >
        <CustomTabs tabs={lessonDetailTabs} color="primary" border={false} />
      </CustomModal>
      {/* <CustomModal compact={} show={lessonDetailModalProps.show} hideModal={() => lessonDetailModalDispatch({ type: modalAction.CLOSE })} centered zIndex={1}>
				<CustomTabs tabs={lessonDetailTabs} color="primary" border={false} />
			</CustomModal> */}
      <AddPaymentModal
        addPaymentModalProps={addPaymentModalProps}
        addPaymentModalDispatch={addPaymentModalDispatch}
        hideModal={() => {
          addPaymentModalDispatch({ type: modalAction.CLOSE });
          // coursePurchaseModalDispatch({ type: modalAction.CLOSE });
        }}
      />
      <CustomModal
        compact={true}
        show={coursePurchaseModalProps.show}
        hideModal={() =>
          coursePurchaseModalDispatch({
            type: modalAction.CLOSE,
          })
        }
        centered={true}
      >
        <CustomTabs tabs={courseDetailTabs} />
      </CustomModal>
    </>
  );
};
